// extracted by mini-css-extract-plugin
export default {"photo":"styles_photo__Hp05K","placeholder":"styles_placeholder__H8No6"};